import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { OnlineSwitchComponent } from '../../components/online-switch/online-switch.component';
@NgModule({
  exports: [
    OnlineSwitchComponent
  ],
  declarations: [
    OnlineSwitchComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule
  ]
})
export class OnlineSwitchModule { }
